module.exports = __webpack_public_path__ + "static/media/wind-warning.736b7b9d.svg";